module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "shot-map.931978f9.webp";